import { render, staticRenderFns } from "./VenueProducts.vue?vue&type=template&id=4a354a3f&scoped=true&"
import script from "./VenueProducts.vue?vue&type=script&lang=js&"
export * from "./VenueProducts.vue?vue&type=script&lang=js&"
import style0 from "./VenueProducts.vue?vue&type=style&index=0&id=4a354a3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a354a3f",
  null
  
)

export default component.exports